import { Injectable } from "@angular/core";
import { HttpWrapperService } from "../http-wrapper.service";
import { IPlaqueItem } from "../../interfaces/plaqueItem.interface";
import { map, Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";
import { IHttpRequestOptions } from "../../interfaces/http-request-option.interface";

@Injectable({
  providedIn: 'root'
})

export class ActivatePlaquesService {
   constructor(private httpWrapperService: HttpWrapperService) {}

  getItemsListAvailableToAttachToPlaque(
    communityId: number,
  ): Observable<IPlaqueItem[]> {
    const url = `Plaque/itemslist/${communityId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
      };
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
        map((response: IPlaqueItem[]) => response)
    );
  }

  attachItemAndActivatePlaque(plaqueId: number, itemId: number): Observable<boolean> {
    const url = `Plaque/activate/${plaqueId}/${itemId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
      };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: boolean) => response)
    );
  }
  getPlaqueStatus(plaqueId: number): Observable<number> {
    const url = `Plaque/status/${plaqueId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
      };
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
        map((response: number) => response)
    );
  }
}